import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment'
import { UserManagerService } from '../../../shared/providers/user-manager.service';
import { BrokerageManagerService } from '../../../shared/providers/brokerage-manager.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../../../shared/providers/loader.service';
import { IBrokerageBrokerInput } from '../../../shared/models/BrokerageBrokerInputModel';
import { IBrokergaCreationalResponseModel } from '../../../shared/models/BrokerageCreationResponseModel';
import { ValidationService } from '../../../shared/providers/validation.service';
import { IBrokerageList } from '../../../shared/models/BrokerageListOutputModel';
import { AuthenticationService } from '../../../shared/auth/authentication.service';


@Component({
  selector: 'app-brokerage-broker-add',
  templateUrl: './brokerage-broker-add.component.html'
})
export class BrokerageBrokerAddComponent implements OnInit {

  constructor(private _toastService: ToastService, private Validation: ValidationService, public authService: AuthenticationService, private http: HttpClient, private _userManagerService: UserManagerService, private _brokerageManagerService: BrokerageManagerService, private Toast: ToastService, private Loader: LoaderService) { }

  dtOptions = {};
  table: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @Input() selectedBrokerageId: number = 0;
  @Input() selectedBrokerage: string = null;
  @Input() modalRef: BsModalRef;
  @Output() closeModal = new EventEmitter();
  @Output() addBroker = new EventEmitter();
  showBroker: boolean = false;
  @Input() selectedBrokers = [];
  users: any[];
  searchValue = "";
  labelForAddOrEdit: string = "";
  brokerageBrokerInputModel = {} as IBrokerageBrokerInput;
  IsLoading = false;
  ngOnInit() {
    this.brokerageBrokerInputModel.BrokerageId = this.selectedBrokerageId;
    this.user = this.authService.user;
    if (this.selectedBrokerageId > 0) {
      const that = this;
      this.dtOptions = {
        pagingType: 'full_numbers',
        "pageLength": 50,
        serverSide: true,
        processing: true,
        info: false,
        language: {
          zeroRecords: null,
          processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
        },
        bLengthChange: false,
        initComplete: () => $('.dataTables_filter').css('display', 'none'),
        ajax: (dataTablesParameters: any, callback: Function) => {
          this.IsLoading = true;
          $("#dtTable thead").hide();
          const filter =
          {
            BrokerageId: that.selectedBrokerageId // data entry staff
          }
          dataTablesParameters.Extra_param = filter;

          const httpHeader = this.Validation.GetAuthHeader();
          that.http
            .post<DataTablesResponse>(
              this.BASE_URL + '/brokerage/getBrokerDetailsByBrokerage',
              dataTablesParameters, httpHeader
            ).subscribe(resp => {

              this.users = resp.data ? resp.data : [];
              if (this.selectedBrokers.length > 0) {
                this.users = this.users.filter(x => this.selectedBrokers.indexOf(x.Id) <= -1);
              }
              if (resp) {
                callback({
                  recordsTotal: resp.recordsTotal,
                  recordsFiltered: resp.recordsFiltered,
                  data: []
                });
                if (resp.data.length === 0) {
                  $(".dataTables_paginate.paging_full_numbers").hide();
                }
                else {
                  $(".dataTables_paginate.paging_full_numbers").show();
                }
                $(".paginate_button.first,.paginate_button.last").hide();
              } else {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              this.IsLoading = false;
            });
        },
        columns: [{ data: 'BrokerName' }]
      };
    }

  }

  addBro() {
    this.brokerageBrokerInputModel.BrokerName = "";
    this.brokerageBrokerInputModel.LastName = "";
    this.brokerageBrokerInputModel.Email = "";
    this.brokerageBrokerInputModel.Phone = "";
    this.brokerageBrokerInputModel.Title = "";
    this.brokerageBrokerInputModel.AdditionalPhone = "";
    this.brokerageBrokerInputModel.ExtensionNumber = "";
    this.showBroker = true;
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  onUserAdd(userId: number, index) {
    this.users.splice(index, 1);
    this._toastService.addToast({
      title: 'Success',
      msg: 'Broker added successfully!',
      timeout: 5000,
      theme: 'bootstrap',
      position: 'bottom-right',
      type: 'success'
    });
    this.addBroker.emit(userId);
    this.selectedBrokers.push(userId);
    if (this.users.length === 0) {
      $(".dataTables_paginate.paging_full_numbers").hide();
      $(".paginate_button.first,.paginate_button.last").hide();
    }
  }

  onBrokerInfoKeydown() {
    this.checkBrokerValidation();
  }

  brokerageValid: boolean = false;
  brokerNameValid: boolean = false;
  brokerTitleValid: boolean = false;
  lastNameValid: boolean = false;
  user: any;
  emailValid: boolean = false;
  phoneValid: boolean = false;
  emailvalidation: string = '';
  phoneValidation: string = '';
  IsValid: boolean = false;
  disabledAddOrEditBtn: boolean = false;
  IsEditMode: boolean = false;
  brokerageList: IBrokerageList[];
  FromBrokerageMaster: boolean = false;
  brokerageCreationResponseModel = {} as IBrokergaCreationalResponseModel;

  checkBrokerValidation() {

    this.IsValid = true;
    if (this.Validation.IsinValid(this.brokerageBrokerInputModel.BrokerageId)) {
      this.brokerageValid = true;
      this.IsValid = false;
    }
    else if (this.brokerageBrokerInputModel.BrokerageId == 0) {
      this.brokerageValid = true;
      this.IsValid = false;
    }
    else {
      this.brokerageValid = false;
    }
    if (this.Validation.IsinValid(this.brokerageBrokerInputModel.BrokerName)) {
      this.brokerNameValid = true;
      this.IsValid = false;
    }
    else {
      this.brokerNameValid = false;
    }
    if (this.Validation.IsinValid(this.brokerageBrokerInputModel.LastName)) {
      this.lastNameValid = true;
      this.IsValid = false;
    }
    else {
      this.lastNameValid = false;
    }
    if (this.Validation.IsinValid(this.brokerageBrokerInputModel.Title)) {
      this.brokerTitleValid = true;
      this.IsValid = false;
    }
    else {
      this.brokerTitleValid = false;
    }
    if (this.Validation.IsinValid(this.brokerageBrokerInputModel.Email)) {
      this.emailValid = true;
      this.IsValid = false;
      this.emailvalidation = "";
    }
    else if ((this.Validation.isEmail(this.brokerageBrokerInputModel.Email) == false) && !this.Validation.IsinValid(this.brokerageBrokerInputModel.Email)) {
      this.emailValid = true;
      this.IsValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = false;
      this.emailvalidation = "";
    }


    if (this.Validation.IsinValid(this.brokerageBrokerInputModel.Phone)) {
      this.phoneValid = true;
      this.IsValid = false;
      this.phoneValidation = "";

    }
    else if (this.Validation.isPhoneNumber(this.brokerageBrokerInputModel.Phone) == false) {
      this.phoneValidation = "Invalid phone number";
      this.phoneValid = true;
      this.IsValid = false;

    }
    else {
      this.phoneValidation = "";
      this.phoneValid = false;
    }

  }

  brokerslist = [];
  addOrEditBroker() {

    this.checkBrokerValidation();
    this.brokerageBrokerInputModel.UserId = this.user.Id;
    if (this.IsValid) {
      this.disabledAddOrEditBtn = true;
      this.brokerageBrokerInputModel.BrokerStatus = 101;
      this._brokerageManagerService.createBroker(this.brokerageBrokerInputModel).subscribe(response => {
        this.brokerageCreationResponseModel = response;

        if (this.brokerageCreationResponseModel.Success == true) {
          this.showBroker = false;
          if (this.dtElement.dtInstance != undefined) {
            this.dtElement.dtInstance.then(x => x.draw(false));
          }

        }
        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: this.brokerageCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }

        this.disabledAddOrEditBtn = false;
      });
    }
    else {
    }
  }

  closeAddBrokerModal() {
    this.showBroker = false;
  }
}
